import { Link } from 'react-router-dom';

import { ProductCardData } from '@/shared/types/ProductCardTypes';
import { useAuthStore } from '@/shared/stores/useAuthStore';
import { formatPrice } from '@/shared/utils/priceUtils';
import { formatDateYYYYMMDD } from '@/shared/utils/dateUtils';

const ProductCard = ({ product }: { product: ProductCardData }) => {
  const {
    categoryId,
    comparedPrice,
    createdAt,
    currencyCode,
    currencySymbol,
    eventApplyEndAt,
    eventApplyStartAt,
    eventType,
    nationCode2,
    optionUuid,
    productUuid,
    releaseDate,
    salesEndAt,
    salesStartAt,
    softDeletedAt,
    statusId,
    tags,
    thumbnailUrl,
    title,
    totalPrice,
    totalSalesAmount,
    totalSalesQuantity,
    updatedAt,
    vendor,
  } = product;

  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <Link to={`/productdetail/${optionUuid}`}>
      <div
        className="relative cursor-pointer rounded-lg bg-white p-4"
        key={productUuid}
      >
        <div className="relative h-[13rem] w-[13rem]">
          {tags.find((tag) => tag === 'sold out') && (
            <div className="absolute flex h-[13rem] w-[13rem] items-center justify-center rounded-[4px] bg-[#22222260]">
              <p className="text-[1.5rem] font-bold text-white">SOLD OUT</p>
            </div>
          )}

          <img
            src={thumbnailUrl}
            alt="product-img"
            className="w-full rounded-[4px] object-cover"
          />
          <div className="absolute left-1/2 top-[-10px] z-10 mb-2 flex translate-x-[-50%] items-center justify-center gap-[4px]">
            {['sale', 'pre', 'new', 'hot']
              .filter((tag) => tags.includes(tag))
              .slice(0, 2)
              .map((tag) => {
                let bg = '';
                if (tag === 'sale') bg = 'bg-[#B995BE]';
                else if (tag === 'pre') bg = 'bg-[#95699f]';
                else if (tag === 'new') bg = 'bg-[#F4CD0E]';
                else if (tag === 'hot') bg = 'bg-[#E652AB]';

                return (
                  <div
                    key={tag}
                    className={`flex h-[20px] items-center justify-center rounded-full ${bg} px-[12px] text-[0.625rem] font-semibold text-white`}
                  >
                    {tag.toUpperCase()}
                  </div>
                );
              })}
          </div>
        </div>
        <div className="mt-[16px]">
          <p className="mb-[8px] line-clamp-2 w-[208px] overflow-hidden text-ellipsis text-sm font-bold leading-[1.4]">
            {title}
          </p>
          <div className="text-xs">
            <p className="mb-[6px] text-xs font-normal text-[#999999]">
              {vendor}
            </p>
            <p className="h-4 text-xs font-normal text-[#8F689A]">
              {releaseDate && `Release : ${formatDateYYYYMMDD(releaseDate)}`}
            </p>
          </div>
        </div>
        <div className="mt-2 flex items-end justify-between">
          <p className="product-price mb-[4px] text-[0.875rem] font-extrabold text-[#444]">
            {isAuthenticated
              ? `${formatPrice(totalPrice || 0, currencyCode)}${currencySymbol}`
              : 'Members Only'}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
